import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Button,
  Box,
  Menu,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  Card,
  CardContent,
  Breadcrumbs,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  Paper,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Dialog,
  DialogContent,
  Switch,
  TableSortLabel,
  OutlinedInput,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { BUTTON_STYLES } from "../../styles/componentStyles";
import NavBar from "../NavBar";
import api from "../../axiosInstance";
import { useTheme } from "@emotion/react";
import DeleteIcon from "@mui/icons-material/Delete";
import CampaignIcon from "@mui/icons-material/Campaign";
import ToastDialog from "./ToastDialog";
import DeleteConfirmationDialog from "../DeleteConfirmationDialog";
import { toast, ToastContainer } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CoursesModal from "./CoursesModal";
import ViewListIcon from "@mui/icons-material/ViewList";
import MergeIcon from "@mui/icons-material/Merge";
import CollegeCourseMapModal from "./CollegeCourseMapModal";
import useStatesUniversities from "../../hooks/useStatesUniversities";
// Column config and visibility state
const allColumns = [
  {
    key: "id",
    label: "ID",
    cellCss: { align: "center", minWidth: "50px" },
    getValue: (r) => r.id,
  },
  {
    key: "universityId",
    label: "University Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r.universityId,
  },
  {
    key: "paymentId",
    label: "Payment Id",
    cellCss: { align: "center", minWidth: "100px" },
    getValue: (r) => r?.payment?.id || "-",
  },
  {
    key: "courseCode",
    label: "Course Code",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.courseCode,
  },
  {
    key: "courseExtension",
    label: "Course Extension",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.courseExtension,
  },
  {
    key: "mentorshipEnable",
    label: "Mentorship Enable",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => (r.mentorshipEnable ? "Yes" : "No"),
  },
  {
    key: "toastMessage",
    label: "Toast Message",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.toastMessage,
  },
  {
    key: "showToast",
    label: "Show Toast",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => (r.showToast ? "Yes" : "No"),
  },
  {
    key: "category",
    label: "Category Name",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.category,
  },
  {
    key: "courseName",
    label: "Course Name",
    cellCss: { align: "center", minWidth: "200px" },
    getValue: (r) => r.courseName,
  },
  {
    key: "paymenttype",
    label: "Payment Type",
    cellCss: { align: "center", minWidth: "140px" },
    getValue: (r) => r?.payment?.type || "-",
  },
  {
    key: "universityName",
    label: "University Name",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.universityId,
  },
  {
    key: "semesters",
    label: "semesters",
    cellCss: { align: "center", minWidth: "150px" },
    getValue: (r) => r.semesters?.join(", "),
  },
  {
    key: "viewable",
    label: "Viewable",
    getValue: (r) => (r.viewable ? "Yes" : "No"),
  },
  {
    key: "active",
    label: "Active",
    getValue: (r) => (r.active ? "Yes" : "No"),
  },

  {
    key: "image",
    label: "Image",
    cellCss: { align: "center", minWidth: "120px" },
    getValue: (r) => r.image,
  },
];
const defaultVisibleKeys = new Set([
  "id",
  "courseCode",
  "category",
  "paymenttype",
  "universityName",
  "courseName",
  "mentorshipEnable",
  "showToast",
  "image",
  "viewable",
]);

const STORAGE_KEY = "coursesVisibleColumns";

function Courses({ active = true }) {
  const navigation = useNavigate();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);
  // Full, unfiltered list — used to resolve a course's university name in the table
  const [allUniversities, setAllUniversities] = useState([]);
  const [openNew, setOpenNew] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const handlecollegemapClose = () => setOpenMap(false);
  const handleNewClose = () => setOpenNew(false);
  const [selectedstates, setSelectedStates] = useState("");
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("courses_management") || "";
  });
  const [nameFilter, setNameFilter] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const [coursesEdit, setCoursesEdit] = useState(null);
  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("category");
  const [order, setOrder] = useState("asc");
  const [totalElements, setTotalElements] = useState("");
  const [collegeMap, setCollegeMap] = useState(null);

  // Inside sorted Data your component
  const sortedData = useMemo(() => {
    if (!courses) return [];

    return [...courses].sort((a, b) => {
      if (!orderBy) return 0;

      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string") {
        return order === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number") {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }
      if (typeof aValue === "boolean") {
        return order === "asc"
          ? Number(aValue) - Number(bValue)
          : Number(bValue) - Number(aValue);
      }
      return 0;
    });
  }, [courses, orderBy, order]);
  // Save to localStorage whenever it changes
  //   useEffect(() => {
  //     localStorage.setItem("courses_management", searchQuery);
  //   }, [searchQuery]);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const handleChange = (event) => {
    setSelectedStates(event.target.value);
    // University choice may no longer belong to the newly selected state
    setSearchQuery("");
  };
  console.log(sortedData);

  // State list + universities scoped to the selected state, both from the shared hook
  const {
    states,
    universities: universitiesByState,
    loadingStates,
    loadingUniversities,
  } = useStatesUniversities(selectedstates);

  //Fetching the courses data with states id
  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/getCourses`, { params: { active } })
      .then((res) => {
        setCourses(res.data.data);
        setTotalElements(res.data.data.totalElements);
      })

      .catch((error) => {
        console.error("There was an error fetching the book details!", error);
        setError("Failed to load books. Please try again.");
      })
      .finally(() => setIsLoading(false));
  }, [active]);
  //Fetching the full University list (for resolving names in the table)
  useEffect(() => {
    setIsLoading(true);
    api
      .get(`/getAllUniversities`)
      .then((res) => {
        setAllUniversities(res.data.data);
      })

      .catch((error) => {
        console.error("There was an error fetching the book details!", error);
        setError("Failed to load books. Please try again.");
      })
      .finally(() => setIsLoading(false));
  }, []);

  // Initialize from localStorage synchronously to avoid a race with the persister effect
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });

  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns)),
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    const normalized = value === true || value === "true" || value === "Yes";
    return (
      <Chip
        label={normalized ? "Yes" : "No"}
        color={normalized ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  // Helper function to get content type chip styling
  const getContentTypeChip = (type) => {
    const typeConfig = {
      text: { color: "primary", label: "Text" },
      image: { color: "secondary", label: "Image" },
      video: { color: "success", label: "Video" },
      link: { color: "info", label: "Link" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };
  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  useEffect(() => {
    setPage(0);
  }, [searchQuery, nameFilter]);

  // pagenation code
  const paginatedFAQ = sortedData;

  // Columns Field showing obeject
  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));
  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };
  // Delete The college record api fetch data
  const handleDelete = async () => {
    try {
      await api.delete(`/api/courses/${selectedId}`);

      // If deletion is successful, update local state update
      setCourses((prev) => prev.filter((row) => row.id !== selectedId));
      toast.success("Record deleted successfully.!", {
        position: "top-right",
        autoClose: 3000,
      });
      setOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete the record. Please try again.");
    }
  };
  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
    setCoursesEdit([]);
  };
  // Editing page data in onclick
  const handleEditClick = (rowData) => {
    handleNewOpen();
    setCoursesEdit(rowData);
  };

  const handleMapClick = (rowData) => {
    handlecollegemapOpen();
    setCollegeMap(rowData);
  };
  const handlecollegemapOpen = () => {
    setOpenMap(true);
    setCollegeMap([]);
  };

  const [toastRow, setToastRow] = useState(null);
  // Success show th response values
  const handleFormSuccess = (newItem) => {
    if (!newItem || !newItem.id) {
      console.warn("Invalid item received from form", newItem);
      return;
    }
    setCourses((prev) => {
      const exists = prev.some((item) => item.id === newItem.id);
      if (exists) {
        console.log("hello");
        return prev.map((item) => (item.id === newItem.id ? newItem : item));
      } else {
        console.log("hi");
        return [newItem, ...prev];
      }
    });

    setCoursesEdit(null);
  };
  let filteredCourses = searchQuery
    ? sortedData.filter((course) => course.universityId === searchQuery)
    : sortedData;
  if (nameFilter.trim()) {
    const term = nameFilter.trim().toLowerCase();
    filteredCourses = filteredCourses.filter((course) =>
      (course.courseName || "").toLowerCase().includes(term),
    );
  }
  //  PaginatedData in after filtering
  const paginatedData = filteredCourses.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  return (
    <>
      {/* <NavBar /> */}
      <ToastContainer />
      {/* <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "flex-start", md: "space-between" },
            alignItems: { xs: "stretch", md: "center" },
            gap: { xs: 1, md: 0 },
            mb: 2,
            marginLeft: "10px",
            marginTop: "10px",
          }}
        >
          <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
            <Link underline="hover" color="inherit" to="/booklist">
              Books List
            </Link>
            <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
              courses Management
            </Typography>
          </Breadcrumbs>

          
        </Box> */}
      {/* Search Section */}
      <Card sx={{ margin: "0 15px", boxShadow: 1 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                flex: "1 1 480px",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                size="small"
                placeholder="Search by course name"
                value={nameFilter}
                onChange={(e) => setNameFilter(e.target.value)}
                sx={{ minWidth: 220 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: nameFilter ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setNameFilter("")}
                        edge="end"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
              <FormControl size="small" fullWidth sx={{ maxWidth: 200 }}>
                <InputLabel>State</InputLabel>

                <Select
                  sx={{ textAlign: "left" }}
                  label="State"
                  value={selectedstates}
                  onChange={handleChange}
                  input={<OutlinedInput label="State" />}
                  disabled={loadingStates}
                >
                  <MenuItem value="">All States</MenuItem>
                  {states.map((s) => (
                    <MenuItem value={s.id} key={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" fullWidth sx={{ maxWidth: 280 }}>
                <InputLabel>Select Univeristy</InputLabel>

                <Select
                  sx={{ textAlign: "left" }}
                  label="Select Univeristy"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  input={<OutlinedInput label="Select Univeristy" />}
                  disabled={loadingUniversities}
                >
                  <MenuItem value="">None</MenuItem>
                  {universitiesByState.map((university) => (
                    <MenuItem value={university.id} key={university.id}>
                      {university.id} {"-"} {university.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Typography
                sx={{ display: { xs: "none", md: "block" } }}
                variant="body2"
                color="text.secondary"
              >
                {paginatedData.length} of {courses.length} Courses
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flexShrink: 0 }}>
              <Box>
                {/* Action Buttons */}
                <Stack
                  direction="row"
                  spacing={2}
                  flexWrap="wrap"
                  useFlexGap
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: 1,
                    flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
                    mt: { xs: 1, md: 0 },
                    marginRight: "10px",
                  }}
                >
                  {active && (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<ViewListIcon />}
                      onClick={() => navigation("/CourseCollegeMap")}
                      {...BUTTON_STYLES.primary}
                      sx={{
                        minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                        fontSize: { xs: "10px", md: "12px" },
                      }}
                    >
                      View Course College Map
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={<ViewColumnIcon />}
                    onClick={handleOpenColumnsMenu}
                    sx={{
                      minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                      fontSize: { xs: "10px", md: "12px" },
                    }}
                  >
                    Columns
                  </Button>
                  <Menu
                    anchorEl={columnsMenuAnchor}
                    open={openColumnsMenu}
                    onClose={handleCloseColumnsMenu}
                    PaperProps={{
                      sx: {
                        width: 200,
                        maxHeight: 500,
                        overflowY: "auto",
                        borderRadius: 2,
                      },
                    }}
                  >
                    {allColumns.map((col) => (
                      <FormControlLabel
                        key={col.key}
                        control={
                          <Checkbox
                            checked={visibleColumns.has(col.key)}
                            onChange={() => toggleColumn(col.key)}
                          />
                        }
                        label={col.label}
                        sx={{ pl: 1, pr: 2 }}
                      />
                    ))}
                  </Menu>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleNewOpen}
                    {...BUTTON_STYLES.primary}
                    sx={{
                      minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                      fontSize: { xs: "10px", md: "12px" },
                    }}
                  >
                    Add Courses
                  </Button>
                </Stack>
              </Box>
              {/* Dense toggle */}
              <Tooltip title="Dense padding" arrow>
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Box>
          </Box>
          <Typography
            sx={{ display: { xs: "block", md: "none" }, textAlign: "left" }}
            variant="body2"
            color="text.secondary"
          >
            {filteredCourses.length} of {courses.length} courses
          </Typography>
        </CardContent>
      </Card>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Fade in={!isLoading}>
          <Paper
            sx={{
              width: "98%",
              mx: "auto",
              overflow: "hidden",
              boxShadow: 2,
              marginBottom: "20px",
            }}
          >
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                stickyHeader
                aria-label="news table"
                size={dense ? "small" : "medium"}
              >
                <TableHead>
                  <TableRow>
                    {visibleColumnDefs.map((c) => (
                      <TableCell
                        key={c.key}
                        sx={{
                          padding: "10px 5px ",
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          ...c.cellCss,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                        sortDirection={orderBy === c.key ? order : false}
                      >
                        <TableSortLabel
                          active={orderBy === c.key}
                          direction={orderBy === c.key ? order : "asc"}
                          onClick={() => handleSort(c.key)}
                          sx={{
                            color: "#ffffff !important",
                            "&.Mui-active": {
                              color: "#ffffff !important",
                            },
                            "& .MuiTableSortLabel-icon": {
                              color: "#ffffff !important",
                            },
                          }}
                        >
                          {c.label}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        backgroundColor: "#17479e",
                        color: "white",
                        fontWeight: 600,
                        minWidth: 120,
                        textAlign: "center",
                        position: "sticky",
                        top: 0,
                        right: 0,
                        zIndex: 4,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(paginatedData) && paginatedData.length > 0 ? (
                    paginatedData.map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        sx={{
                          "&:nth-of-type(odd)": {
                            backgroundColor: "rgba(0, 0, 0, 0.02)",
                          },
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        {visibleColumnDefs.map((c) => (
                          <TableCell
                            key={c.key}
                            sx={{ padding: "10px 10px", ...c.cellCss }}
                          >
                            {(() => {
                              const value = c.getValue(row);
                              const key = c.key;

                              // Optional debug

                              if (
                                key === "viewable" ||
                                key === "showToast" ||
                                key === "active" ||
                                key === "mentorshipEnable"
                              ) {
                                return getBooleanChip(value);
                              }

                              if (key === "universityName") {
                                const university = allUniversities.find(
                                  (u) => u.id === value,
                                );

                                return university ? university.name : "-";
                              }

                              if (key === "image") {
                                return key === "image" ? (
                                  <img
                                    src={`https://siaedutech.com/public/${value}`}
                                    alt="preview"
                                    style={{
                                      width: "60px",
                                      height: "auto",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setOpenImage(
                                        `https://siaedutech.com/public/${value}`,
                                      )
                                    }
                                  />
                                ) : (
                                  value // show fallback text if not valid image
                                );
                              }

                              return value;
                            })()}
                          </TableCell>
                        ))}
                        <TableCell
                          sx={{
                            align: "center",
                            padding: "10px 10px",
                            minWidth: "120px",
                            position: "sticky",
                            right: 0,
                            backgroundColor: "#fff",
                            zIndex: 1,
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={0.5}
                            justifyContent="center"
                          >
                            <Tooltip title="Edit Course" arrow placement="top">
                              <IconButton
                                color="primary"
                                onClick={() => handleEditClick(row)}
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {/* <Tooltip
                              title="Course Mapping"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  navigate("/college_courses", {
                                    state: row.id,
                                  })
                                }
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <NoteAddIcon fontSize="small" />
                              </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Course Toast" arrow placement="top">
                              <IconButton
                                color="secondary"
                                onClick={() => setToastRow(row)}
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "secondary.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <CampaignIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title="Delete Course"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="error"
                                onClick={() => handleClickOpen(row.id)}
                                size="small"
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "error.light",
                                    color: "white",
                                  },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title="Course College Mapping"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="#0dec84"
                                onClick={() => handleMapClick(row)}
                                size="small"
                                sx={{
                                  color: "#0b6a3e",
                                  "&:hover": {
                                    backgroundColor: "#0b6a3e",
                                    color: "white",
                                  },
                                }}
                              >
                                <MergeIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnDefs.length + 1}
                        sx={{ textAlign: "center", py: 4 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            {searchQuery
                              ? "No courses found matching your search"
                              : "No courses available"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              onClick={() => setSearchQuery("")}
                              startIcon={<SearchIcon />}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 30, 50, 100]}
              component="div"
              count={filteredCourses.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid",
                borderColor: "divider",
                "& .MuiTablePagination-toolbar": {
                  paddingLeft: 2,
                  paddingRight: 2,
                },
              }}
            />
          </Paper>
        </Fade>
      )}
      {/* Banner modal */}
      <CoursesModal
        open={openNew}
        onClose={handleNewClose}
        coursesEdit={coursesEdit}
        onSuccess={handleFormSuccess}
      />
      <CollegeCourseMapModal
        open={openMap}
        onClose={handlecollegemapClose}
        collegeMap={collegeMap}
        onSuccess={handleFormSuccess}
      />
      <ToastDialog
        row={toastRow}
        url={`/api/courses/${toastRow?.id}/toast`}
        title={`Toast: ${toastRow?.courseName || ""}`}
        onClose={() => setToastRow(null)}
        onSuccess={handleFormSuccess}
      />
      {/* Confirm Delete Dialog */}
      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this news item? This action cannot be undone."
        confirmText="DELETE"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
      <Dialog
        open={!!openImage}
        onClose={() => setOpenImage(null)}
        maxWidth="md"
      >
        <DialogContent>
          <Box position="relative">
            <IconButton
              aria-label="close"
              onClick={() => setOpenImage(null)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={openImage}
              alt="Preview"
              style={{ width: "100%", height: "auto", borderRadius: 4 }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Courses;
